export default __webpack_public_path__ + "static/media/hardening-icon.e0dee0fb.svg";